import { FormControlLabel, Paper, Switch } from "@mui/material";
import { color } from "../../../../theme/color";
import React, { ComponentState, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  saveClientDiagnosis,
  getClientTreatmentPlanSign,
  ApplyClientSignature,
  getTreatmentPlan,
  getTreatmentPlanReSignNotifications,
} from "../../../../redux/actions";
import SkeletonTypography from "../../../../components/SkeletonTypography";
import { ResponseTreatmentPlan } from "../../../../dataModel/clientModels";
import {
  ExpansionPanel,
  ExpansionPanelContent,
} from "@progress/kendo-react-all";
import moment from "moment";
import { GenericResponseModel } from "../../../../dataModel/authModels";
import { doc } from "../../../../services/docuemnt";
import ListTreatmentGoal from "./list-goal";
import DatePickerKendoRct from "../../../../control-components/date-picker";
import DropDownListComponent from "../../../../control-components/drop-down";
import { useLocation } from "react-router-dom";

export const TreatmentPlan = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [showPastDx, setShowPastDx] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isListFetched, setListFetched] = useState(false);
  const [expandedPlan, setExpandedPlan] = React.useState<any>([]);
  const [, setSelectedPlan] = useState();
  const [pinInput, setPinInput] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedSignatureOwner, setSelectedSignatureOwner] =
    useState();
  const [selectedSignAlreadyApplied, setSelectedSignAlreadyApplied] =
    useState(false);
  const [wrongPin, setWrongPin] = useState(false);
  const [signatureApplied, setSignatureApplied] = useState(false);
  const [makeButtonDisabled, setMakeButtonDisabled] = useState(false);
  const [availableSignature, setAvailableSignature] = useState<string[]>([]);
  const [, setBothSignatureAvailable] = useState(false);
  const [, setCSAlreadyAvailable] = useState(false);
  const [, setPSAlreadyAvailable] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState<string | undefined>(undefined);
  const planIdFromNotification = location.state?.tpPlanId;
  const state: ComponentState = useSelector((states) => {
    return states;
  });
  const { treatmentPlanResponseList } = state["ClientReducer"];

  const flatTreatmentPlanList = Array.isArray(treatmentPlanResponseList?.[0])
    ? treatmentPlanResponseList[0]
    : treatmentPlanResponseList || [];
  const { signatureOwner } = state["TreatmentPlanSignReducer"];
  useEffect(() => {
    if (flatTreatmentPlanList) {
      setLoading(false);
    }
  }, [flatTreatmentPlanList]);

  let payload = {
    signatureType: 1,
    pin: pinInput,
    sigDateTime: selectedDate,
    isParent: selectedSignatureOwner === "parent",
    id: selectedPlanId
  };

  let payloadPin = {
    isParent: selectedSignatureOwner === "parent",
    pin: pinInput,
  };

  useEffect(() => {
    if (!isListFetched) {
      setLoading(true);
      dispatch(getTreatmentPlan(!showPastDx));
      setListFetched(true);
    }
  }, [isListFetched]);

  useEffect(() => {
    if (flatTreatmentPlanList) {
      setLoading(false);
      const expandedState = flatTreatmentPlanList.reduce((acc: any, plan: any) => {
        acc[plan?.id] = true;
        return acc;
      }, {});
      setExpandedPlan(expandedState);
    }
  }, [flatTreatmentPlanList]);

  useEffect(() => {
    if (isListFetched) {
      dispatch(getTreatmentPlan(!showPastDx));
    }
  }, [showPastDx]);

  useEffect(() => {
    if (signatureApplied) {
      setTimeout(() => { setSignatureApplied(false); }, 10000)
    }
  }, [signatureApplied]);

  useEffect(() => {

    if (flatTreatmentPlanList && flatTreatmentPlanList[0] && flatTreatmentPlanList[0].id) {
      dispatch(getClientTreatmentPlanSign(flatTreatmentPlanList[0]?.id));
    } else {

      dispatch({ type: 'SAVE_CLIENT_TREATMENT_PLAN_SIGN', payload: {} });
    }
  }, [flatTreatmentPlanList]);

  useEffect(() => {
    if (!pinInput || !selectedDate) {
      setMakeButtonDisabled(true);
    } else {
      setMakeButtonDisabled(false);
    }
  }, [makeButtonDisabled, pinInput, selectedDate, selectedSignatureOwner]);

  const onActionPlans = React.useCallback(
    (event: any, obj: any) => {
      setExpandedPlan({ ...expandedPlan, [obj.id]: !expandedPlan[obj.id] });
      if (event.expanded === false) {
        setSelectedPlan(obj);
      }
    },
    [expandedPlan]
  );
  useEffect(() => {
    if (signatureOwner && signatureOwner.length > 0) {
      signatureOwner[0].map((owner: any, index: any) => {
        const { isParent } = owner;
        if (isParent === true) {
          setPSAlreadyAvailable(true)
          handleChangeSignatureOwner("client");
          setAvailableSignature((prev) => [...prev, "client"]);
        } else {
          setCSAlreadyAvailable(true)
          handleChangeSignatureOwner("parent");
          setAvailableSignature((prev) => [...prev, "parent"]);
        }
      });
    }
  }, [signatureOwner]);

  useEffect(() => {
    if (availableSignature.includes("client") && availableSignature.includes("parent")) {
      setBothSignatureAvailable(true);
    } else {
      setBothSignatureAvailable(false);
    }
  }, [availableSignature])


  const handlePinInputChange = (e: any) => {
    setPinInput(e.target.value);
  };

  const handleDateChange = (e: any) => {
    setSelectedDate(e.target.value);
  };

  const validatePin = async (payloadPin: any): Promise<boolean> => {
    setWrongPin(false);
    const validateResp: GenericResponseModel = await doc.validatePins(
      `isParentSig=${payloadPin.isParent}&pin=${payloadPin.pin}`
    );
    if (validateResp?.status === true) {
      return true;
    } else {
      setWrongPin(true);
      return false;
    }
  };


  const handleApplySignature = async (e: any) => {
    if (signatureOwner[0]) {
      signatureOwner[0].forEach((item: any) => {
        const { isParent } = item;
        if (isParent === false) {
          if (selectedSignatureOwner === "client") {
            setSelectedSignAlreadyApplied(true);
          }
        } else if (isParent === true) {
          if (selectedSignatureOwner === "parent") {
            setSelectedSignAlreadyApplied(true);
          }
        }
      });
    }
    if (!selectedSignAlreadyApplied) {
      const isValidPin = await validatePin(payloadPin);
      if (isValidPin) {
        const payloadToSend = {
          ...payload,
          sigDateTime: moment(selectedDate).format("MM/DD/YYYY"), 
        };
        dispatch(ApplyClientSignature({ payload: payloadToSend, id: selectedPlanId }));
        setTimeout(() => {
          dispatch(getTreatmentPlanReSignNotifications());
        }, 1000);

        setSignatureApplied(true);
        handlePinInputChange({ target: { value: "" } });
      }
    }
  };

  const handleChangeSignatureOwner = (e: any) => {
    setSelectedSignatureOwner(e.target?.value || e);
  };

  useEffect(() => {
    const defaultPlanId = flatTreatmentPlanList?.[0]?.id;
    if (defaultPlanId) {
      setSelectedPlanId(String(planIdFromNotification ?? defaultPlanId));
    } else {
      setSelectedPlanId(undefined);
    }
  }, [flatTreatmentPlanList, planIdFromNotification]);

  useEffect(() => {
    if (selectedPlanId) {
      dispatch(getClientTreatmentPlanSign(selectedPlanId));
    } else {
      dispatch({ type: 'SAVE_CLIENT_TREATMENT_PLAN_SIGN', payload: {} });
    }
  }, [selectedPlanId, dispatch]);

  return (
    <>
      <div className="infoWrapper" >
        <div className="tab-pane treatment-plan-head" role="tabpanel">
          <h1 style={{ fontSize: "22px", fontWeight: "600" }}>
            <div color={color.palette.black}></div>
            Treatment Plan
          </h1>

          {flatTreatmentPlanList && flatTreatmentPlanList.length > 1 && (
            <div className="mb-3">
              <label className="form-label fw-semibold">Select Treatment Plan:</label>
              <DropDownListComponent
                data={flatTreatmentPlanList}
                textField="planName"
                dataItemKey="id"
                value={flatTreatmentPlanList.find((plan: ResponseTreatmentPlan) => String(plan.id) === selectedPlanId) || null}
                onChange={e => setSelectedPlanId(String(e.target.value.id))}
                label=""
                style={{ width: '20%' }}
              />
            </div>

          )}
          <FormControlLabel
            control={
              <Switch
                checked={showPastDx}
                onChange={() => {
                  setShowPastDx(!showPastDx);
                  setLoading(true);
                  dispatch(saveClientDiagnosis());
                }}
              />
            }
            label="Show Closed/Completed Plan"
          />
          {loading ? (
            <SkeletonTypography />
          ) : flatTreatmentPlanList == null ||
            flatTreatmentPlanList.length < 1 ||
            flatTreatmentPlanList[0] == null ? (
            <div>No Treatment Available</div>
          ) : (
            <div>
              {flatTreatmentPlanList &&
                flatTreatmentPlanList
                  .filter((plan: ResponseTreatmentPlan) => String(plan.id) === selectedPlanId)
                  .map((parentItem: ResponseTreatmentPlan) => (
                    <ExpansionPanel
                      id={parentItem.id + "rand"}
                      title={parentItem.planName}
                      tabIndex={0}
                      key={parentItem.id}
                      expanded={expandedPlan[parentItem.id]}
                      onAction={(event: any) => {
                        onActionPlans(event, parentItem);
                      }}
                    >
                      {expandedPlan[parentItem.id] && (
                        <ExpansionPanelContent>
                          <div className="show-upper-event d-flex justify-content-between  py-2 align-items-center"></div>
                          <div className="date-timeshow px-3">
                            <p className="mb-2">
                              {" "}
                              <span className="k-icon k-i-calendar-date orange-text-theme "></span>
                              <b>Plan Date: </b>{" "}
                              {parentItem.planDate === null
                                ? ""
                                : moment(parentItem.planDate).format("M/D/YYYY")}
                            </p>
                            <p className="mb-2">
                              {" "}
                              <span className="k-icon k-i-calendar-date orange-text-theme "></span>
                              <b>Plan End Date: </b>{" "}
                              {parentItem.planEndDate === null
                                ? "-/-/-"
                                : moment(parentItem.planEndDate).format("M/D/YYYY")}
                            </p>
                            <p className="mb-2">
                              <span className="k-icon k-i-calendar-date orange-text-theme"></span>
                              <b>Discharge/Transition Date: </b>{" "}
                              {parentItem?.dateDischarge
                                ? moment(parentItem?.dateDischarge).format(
                                  "M/D/YYYY"
                                )
                                : " -/-"}
                            </p>
                            <p className="mb-2">
                              <span className="k-icon k-i-calendar-date orange-text-theme"></span>
                              <b>Start Time: </b>{" "}
                              {parentItem?.startTime
                                ? parentItem?.startTime
                                : " -/-"}
                            </p>
                            <p className="mb-2">
                              <span className="k-icon k-i-calendar-date orange-text-theme"></span>
                              <b>End Time: </b>{" "}
                              {parentItem?.endTime ? parentItem?.endTime : " -/-"}
                            </p>
                            <p className="mb-2">
                              {" "}
                              <b>Service: </b> {parentItem.serviceName}
                            </p>
                            <p className="mb-2">
                              {" "}
                              <b>Place of Service: </b> {parentItem.placeOfService ? parentItem.placeOfService : " -/-"}
                            </p>

                            <p className="mb-2">
                              <b>
                                Individual/Family was an active participant in the
                                development of the service plan and identified the
                                goals?:{" "}
                              </b>{" "}
                              {parentItem.activeParticipant ? "Yes" : "No"}
                            </p>
                            <p className="mb-2">
                              <b>Transition Discharge Plan: </b>
                              {parentItem.transitionDischargePlan}
                            </p>
                            <p className="mb-2">
                              <b>Maintenance Recommendation: </b>
                              {parentItem.maintenanceRecommendation}
                            </p>
                            <p className="mb-2">
                              <b>Client Strengths: </b>
                              {parentItem.strengths}
                            </p>
                            <p className="mb-2">
                              <b>Client Needs: </b>
                              {parentItem.needs}
                            </p>
                            <p className="mb-2">
                              <b>Client Abilities: </b>
                              {parentItem.abilities}
                            </p>
                            <p className="mb-2">
                              <b>Client Preferences: </b>
                              {parentItem.preferences}
                            </p>
                            <p className="mb-2">
                              <b>Crisis Planning: </b>
                              {parentItem.planning}
                            </p>
                            <p className="mb-2">
                              <b>Step Down Services: </b>
                              {parentItem.stepDownServices}
                            </p>
                            <p className="mb-2">
                              <b>Discharge Planning: </b>
                              {parentItem.dischargePlanning}
                            </p>
                            <p className="mb-2">
                              <b>Other agencies and/or providers working with this client: </b>
                              {parentItem.otherAgencies}
                            </p>
                          </div>
                          <ListTreatmentGoal goalData={parentItem?.goals} />
                        </ExpansionPanelContent>
                      )}
                    </ExpansionPanel>
                  ))}
            </div>
          )}
        </div>

        {!loading && flatTreatmentPlanList && flatTreatmentPlanList.length > 0 && flatTreatmentPlanList[0] != null && (() => {

          let clientSigned = false;
          let parentSigned = false;
          if (signatureOwner && signatureOwner.length > 0) {
            signatureOwner[0].forEach((owner: any) => {
              if (owner.isParent === true) parentSigned = true;
              if (owner.isParent === false) clientSigned = true;
            });
          }

          if (clientSigned && parentSigned) return null;
          return (
            <div
              className="mt-3 tab-pane treatment-plan-head"
              style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <label className="" htmlFor="dropdown">
                  Choose a Signature:
                </label>
                <select
                  id="dropdown"
                  value={selectedSignatureOwner}
                  onChange={handleChangeSignatureOwner}
                  style={{ padding: '2px' }}
                >
                  {!clientSigned && <option value="client">Client</option>}
                  {!parentSigned && <option value="parent">Parent</option>}
                </select>
              </div>
              <div>
                <DatePickerKendoRct
                  onChange={handleDateChange}
                  format={"MM/dd/YYYY"}
                  name={"dateDischarge"}
                  value={selectedDate}
                  placeholder={"Date Signature"}
                />
              </div>
              <input
                type="password"
                className="pl-1 responsiveMax"
                maxLength={4}
                minLength={4}
                onChange={handlePinInputChange}
                name="pinInput"
                value={pinInput}
                placeholder="Enter PIN"
                autoComplete="off"
              />
              <button
                disabled={makeButtonDisabled}
                className="btn btn-green responsiveBtn"
                onClick={handleApplySignature}
              >
                Apply Signature
              </button>
              {selectedSignAlreadyApplied && (
                <div className="ml-3" style={{ color: "red", display: "inline" }}>
                  Signature already applied
                </div>
              )}
              {wrongPin && (
                <div className="ml-3" style={{ color: "red", display: "inline" }}>
                  Please enter a valid pin
                </div>
              )}
              {signatureApplied && (
                <div className="ml-3" style={{ color: "green", display: "inline" }}>
                  Signature Applied Successfully
                </div>
              )}
            </div>
          );
        })()}

        {signatureOwner && signatureOwner.length > 0 && flatTreatmentPlanList && flatTreatmentPlanList.length > 0 && flatTreatmentPlanList[0] != null && (
          <div className="row treatment-plan-head">
            {signatureOwner[0].map((owner: any, index: any) => (
              <div
                key={index}
                className="mt-3 col-md-6 col-am-12 "
              >
                <div className="border p-3 mb-3">
                  <div>
                    <p className="mb-0 text-grey ">
                      {(!owner.signature && owner.signatureId === 0) ? (
                        <>
                          Consent by:{" "}
                          {owner.isParent === true
                            ? owner.parentName
                              ? `${owner.parentName} (Parent/Guardian)`
                              : `${owner.fullNameAtSig} (Parent/Guardian)`
                            : `${owner.clientName} (Client)`
                          }
                        </>
                      ) : (
                        <>
                          Signed by: <span>{owner.fullNameAtSig}</span>{" "}
                          {owner.isParent === true ?
                            (!owner.parentName || owner.parentName === "" ? " (Parent/Guardian)" : ` (${owner.parentName} Parent/Guardian)`)
                            : " (Client)"}
                        </>
                      )}
                    </p>
                    <p className="mb-0 text-grey">
                      Date: {owner.sigDateTime ? moment(owner.sigDateTime).format("M/D/YYYY") : "-"}
                    </p>
                    {(!owner.signature && owner.signatureId === 0) && (
                      <div className="f-9 mb-0 text-grey signPara">
                        Verbal Consent
                      </div>
                    )}
                  </div>
                  {(!owner.signature && owner.signatureId === 0) ? null : (
                    <>
                      <img
                        className="signImage"
                        alt="demo"
                        src={"data:image/png;base64," + owner.signature}
                        style={{ maxHeight: "140px" }}
                      />
                      <p className="f-9 mb-0 text-grey signPara">
                        Electronically signed:{" "}
                        {moment
                          .utc(owner.utcDateCreated)
                          .local()
                          .format("M/D/YYYY hh:mm A")}
                      </p>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
